import { addFilter, removeFilter } from '@wordpress/hooks';
// import UtilitiesTabContent from './WPTravelUtilitiesTabContent'
import TabsTabContent from './sub-components/WPTravelTabsTabContent'
import ItineraryImageField from './sub-components/ItineraryImageField'
import TripTime from './sub-components/TripTime'
import AddNewCategory from './sub-components/AddNewCategory'
import PricingOptions from './sub-components/PricingOptions'
import CustomBooking from './sub-components/CustomBooking'
import ShowHighPrice from './sub-components/ShowHighPrice';
import DurationValidation from './sub-components/DurationValidation';
import { __ } from '@wordpress/i18n';
const __i18n = {..._wp_travel_admin.strings}
// import PriceMinMaxEge from './sub-components/PriceMinMaxEge';

addFilter(
    'wp_travel_itinerary_custom_tabs',
    'wp_travel',
    (content, ...data) => {
        content.splice(0, 1) // Removes the Utilites Notice (Notice must be in index 0)
        return [...content, <TabsTabContent key="utilitiesTabContent" data={data} />]
    },
    15
);

addFilter(
    'wp_travel_itinerary_list_before_description',
    'wp_travel',
    (content, ...params) => {
        return [
            ...content,
            <ItineraryImageField itineraryId={params[0]} itineraryUpdater={params[1]} />
        ]
    }
);

addFilter(
    'show_heighest_price_after_add_price',
    'wp-travel',
    ( content, ...allData ) => {
        return [
            ...content,
            <ShowHighPrice allDatas={allData[0]} />
        ]
    }
);

addFilter(
    'wp_travel_after_end_date',
    'wp_travel',
    (content, ...params) => {
        return [
            ...content,
            <TripTime dates={params[0]} _dateIndex={params[1]} _date={params[2]} onUpdate={params[3]} storeKey={params[4]} />
        ]
    }
);

addFilter(
    'wp_travel_pricing_option_content_after_category',
    'wp_travel',
    (content, ...params ) => {
        return [
            ...content,
            <AddNewCategory price={params[0]} priceIndex={params[1]} />
        ]
    }
);

addFilter(
    'wp_travel_before_pricings_options',
    'wp_travel',
    (content, data) => {
        content.splice(0, 1 ) // Removes index 0 [Note : Index 0 is always used for notice.]
        return [
            ...content,
            <PricingOptions data={data} />
        ]
    }
);

const CustomBookingCB = ( content, allData ) => {
    return [ ...content, <CustomBooking allData={allData} /> ];
}

removeFilter('wp_travel_after_pricings_options', 'WPTravel/TripEdit/PriceDates/MorePricingNotice' );
addFilter('wp_travel_after_pricings_options', 'WPTravelPro\TripEdit\PriceDates\CustomBooking', CustomBookingCB, 20 );

addFilter(
    'wp_travel_after_dates_options',
    'wp_travel',
    (content, data) => {
        content.splice(0, 1 ) // Removes the trip_code field (field must be in index 0)
        return content
    }
);

addFilter(
    'wp_travel_trip_extras_notice',
    'wp_travel',
    (content, data) => {
        content.splice(0, 1 ) // Removes the trip_code field (field must be in index 0)
        return content
    }
);
addFilter( 'wp_travel_trip_duration_validation', 'wp-travel', ( content, allData ) => {
    return [...content, <DurationValidation allData={allData} />];
} );
addFilter( 'wp_travel_trip_duration_formate_select', 'wp-travel', ( context ) => {
    const translatedSelectLabel = __i18n.duration_select_label;
    const val = [
        {label : translatedSelectLabel.day_hour,        value : 'day_hour' },
        {label : translatedSelectLabel.hour_minute,     value : 'hour_minute' },
        {label : translatedSelectLabel.day,             value : 'day' },
        {label : translatedSelectLabel.night,           value : 'night' },
    ]
    return [...context, ...val] 
});


import './Components/Itinerary';
import './Components/Checkout';
import './Components/Faqs';
import './Components/Tabs';

